import React from "react";
import "../Services/Services.css";

const OurServicesFullPreview = ({ previewService, setShowPreviewOurServiceFull }) => {
    if (!previewService) return null;

    const { ourservice, listitems } = previewService;

    return (
        <div
            className="osp-overlay"
            onClick={() => setShowPreviewOurServiceFull(false)}
        >
            <div
                className="osp-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="service-preview-close"
                    onClick={() => setShowPreviewOurServiceFull(false)}
                >
                    ✕
                </button>

                <div className="service-preview-header">
                    <h1>Services</h1>
                    <p>Home &gt; <span className="about-preview-subtitle">Services</span></p>
                </div>

              
                <div className="osp-section">
                    <span className="osp-small-title">
                        {ourservice?.heading}
                    </span>
                    <h2>{ourservice?.title}</h2>
                </div>

              
                <div className="osp-grid">
                    {listitems?.map((item) => (
                        <div className="service-card " key={item.listofservice_id}>
                            <img
                                src={item.image}
                                alt={item.heading}
                                className="osp-card-image"
                            />


                            <div className="osp-card-body">
                                <h3>{item.heading}  <span className="osp-arrow">↗</span></h3>

                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: item.description
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OurServicesFullPreview;
